<template>
  <div class="view-body">
      <div class="view-data">
        <div class="view-data__header">
          <h1>{{title}}</h1>
        </div>
        <div class="form">
          <div class="alert alert-danger" v-if="exist">
            Podany adres e-mail został wykorzystany do utworzenia konta innego użytkownika.
          </div>
          <form @submit.prevent="onSubmit">
          <div class="row">
            <div class="col">
              <div class="form-group" :class="{ 'input-error': $v.fullName.$error }">
                <label>Imię i nazwisko*</label>
                <input class="form-control form-control-lg" type="text" v-model="fullName"/>
                <labelInfo v-if="!$v.fullName.required" type="error" message="To pole jest wymagane"/>
                <labelInfo v-if="!$v.fullName.minLength" type="error" message="Wprowadź minimum 4 znaki"/>
              </div>
              <div class="form-group" :class="{ 'input-error': $v.email.$error }">
                <label>E-mail*</label>
                <input class="form-control form-control-lg" type="text" name="" v-model="email"/>
                <labelInfo v-if="!$v.email.email" type="error" message="Podaj prawidłowy adres e-mail"/>
                <labelInfo v-if="!$v.email.required" type="error" message="To pole jest wymagane"/>
              </div>
              <div class="form-group" :class="{ 'input-error': $v.company.$error }">
                <label>Nazwa firmy*</label>
                <vueselect class="select--list" :options="companiees" v-model="company" :reduce="company => company.value">
                  <option v-for="company in companiees" :key="company.id" :value="company.id">{{company.name}}</option>
                    <template slot="no-options">
                             <p>Brak rekordów</p>
                          </template>
                </vueselect>
                <labelInfo v-if="!$v.company.required" type="error" message="To pole jest wymagane"/>
              </div>
              <div class="form-group" :class="{ 'input-error': $v.role.$error }">
                <label>Uprawnienia*</label>
                <vueselect class="select--list" :options="roles" v-model="role" :value="role" :resetOnOptionsChange="true" :reduce="role => role.value">
                    <template slot="no-options">
                             <p>Brak rekordów</p>
                          </template>
                </vueselect>
                <labelInfo v-if="!$v.role.required" type="error" message="To pole jest wymagane"/>
              </div>
              <div class="form-group" :class="{ 'input-error': $v.category.$error }">
                <label>Kategoria*</label>
                <vueselect class="select--list" :options="categories" v-model="category" :value="category" :resetOnOptionsChange="true" :reduce="category => category.value">
                    <template slot="no-options">
                             <p>Brak rekordów</p>
                          </template>
                </vueselect>
                <labelInfo v-if="!$v.category.required" type="error" message="To pole jest wymagane"/>
              </div>
            </div>
            <div class="col">
              <div class="form-group" :class="{ 'input-error': $v.parentMarket.$error }" v-if="company === 2 || company == null">
                <label>Market macierzysty*</label>
                <vueselect :options="markets" label="sapNumber" class="select--list" v-model="parentMarket" :reduce="parentMarket => parentMarket.id">
                  <template slot="selected-option" slot-scope="option">
                      {{option.sapNumber}} {{option.gallery_city}} {{option.number}} {{option.gallery}} {{option.category ? option.category.name : ''}}
                  </template>
                  <template slot="option" slot-scope="option">
                      {{option.sapNumber}} {{option.gallery_city}} {{option.number}} {{option.gallery}} {{option.category ? option.category.name : ''}}
                  </template>
                    <template slot="no-options">
                             <p>Brak rekordów</p>
                          </template>
                </vueselect>
                <labelInfo v-if="!$v.parentMarket.required" type="error" message="To pole jest wymagane"/>
              </div>
              <div class="form-group" v-on-clickaway="closeList" v-if="company === 2 || company == null">
                <label>Markety podrzędne</label>
                <div class="form-control form-control-lg sub-markets-display" v-show="!showList" @click="showList = !showList">
                  <div class="sub-markets-display__body">
                    <ul>
                      <li v-for="market in subMarkets">{{market.sapNumber}} {{market.gallery_city}} {{market.number}} {{market.gallery}} {{market.category ? market.category.name : ''}},</li>
                    </ul>
                  </div>
                </div>
                <img class ="form-group__icon" src="@/assets/symbols/search.svg" v-if="!showList">
                <input class="form-control form-control-lg search" type="text" v-model="search" v-show="showList" placeholder="Szukaj"/>
                <img class ="form-group__icon" src="@/assets/symbols/search.svg">
                <ul class="list-group list-group--form" v-show="showList">
                  <li class="list-group-item list-group-item--form d-flex justify-content-between align-items-center" v-for="market in markets" :key="market.id">
                     {{market.sapNumber}} {{market.gallery_city}} {{market.number}} {{market.gallery}} {{market.category ? market.category.name : ''}}
                    <label class="checkbox checkbox--form multi-checkbox-wide"><input type="checkbox" :value="market.id" @click="pushSubMarkets()"><span class="checkmark"></span></label>
                  </li>
                </ul>
              </div>
              <div class="form-group" :class="{ 'input-error': $v.status.$error }">
                <label>Status*</label>
                <vueselect class="select--list" disabled>
                  <option value="active">Aktywny</option>
                    <template slot="no-options">
                             <p>Brak rekordów</p>
                          </template>
                </vueselect>
                <labelInfo v-if="!$v.status.required" type="error" message="To pole jest wymagane"/>
              </div>
            </div>
          </div>
          <div class="form-footer">
            <p class="form-footer__paragraph">* pola wymagane</p>
            <button class="button-normal button-normal--media">Dodaj</button>
          </div>
          </form>
        </div>
      </div>
  </div>
</template>

<script>

import { validationMixin } from 'vuelidate'
import { required, email, minLength } from 'vuelidate/lib/validators'
import labelInfo from '@/components/blocks/labelInfo.vue';
import { mixin as clickaway } from 'vue-clickaway';


const touchMap = new WeakMap()

export default {
  name: 'UserAdd',
  components:{

    labelInfo,

  },
  mixins: [validationMixin, clickaway],
  data () {
    return {

      title: 'Nowy użytkownik',
      markets: [],
      subMarkets: [],

      categories: [],
      companiees: [],
      categoriesGun: [],
      categoriesMm: [],
      roles: [],
      rolesGun: [],
      rolesMm: [],

      fullName: '',
      email: '',
      company: '',
      role: '',
      category: '',
      parentMarket: '',
      status: 'active',

      showList: false,
      search: '',

      exist: false,

    }
  },
  validations: {

    fullName: {

      required,
      minLength: minLength(4)

    },
    email: {

      required,
      email

    },
    company: {

      required,

    },
    role: {

      required,

    },
    category: {

      required,

    },
    parentMarket: {

      isGut (){
        return this.isGut();
      },

    },
    status: {

      required,

    },
  },
  watch: {
    company: function(value){
      if ( value == 1 ) {
        this.categories = this.categoriesGun;
        this.roles      = this.rolesGun;
      } else {
        this.categories = this.categoriesMm;
        this.roles      = this.rolesMm;
      }
      this.role = this.roles[0].value;
      this.category = this.categories[0].value;
    }
  },
  methods:{

    getFormData(){

      const token = localStorage.getItem('auth_token');

      this.$http.get('users/form/data', {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }})
        .then(response => {

          let companiees  = response.data.company;
          let categories  = response.data.category;
          let roles       = response.data.role;
          
          companiees.forEach((item)=>{
            this.companiees.push({value: item.id, label: item.name});
          });

          categories.forEach((item)=>{
            if ( item.id == 1 ) {
              this.categoriesGun.push({value: item.id, label: item.name});
            } else {
              this.categoriesMm.push({value: item.id, label: item.name});
            }
          });

          roles.forEach((item)=>{
            if ( item.id == 'ROLE_COORDINATOR' || item.id == 'ROLE_EDITOR' || item.id == 'ROLE_ADMIN' ) {
              this.rolesGun.push({value: item.id, label: item.name});
            } 

            if ( item.id == 'ROLE_LOCAL' || item.id == 'ROLE_CENTRAL' ) {
              this.rolesMm.push({value: item.id, label: item.name});
            }
          });
              
        })
        .catch(error =>{

            console.error(error.response);

        })

    },

    isGut(){
      
      if(this.company == 2){

        if(this.parentMarket != ''){
          return true;
        }

        return false;

      }

      return true;

    },

    getMarkets(){

      const token = localStorage.getItem('auth_token');

      this.$http.get('market/markets', {
        params:{

          'limit': 100,

        },
        headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
        } }).then(response => {

          this.markets = response.data.list;

        })

    },

    closeList(){

      this.showList = false;

    },

    pushSubMarkets(){

      let checkboxes = document.querySelectorAll("input[type='checkbox']");

      for (let i = 0; i < checkboxes.length; i++) {

        
        let market = this.markets.filter(market => market.id == checkboxes[i].value);
        let submarket = this.subMarkets.find(sub => sub.id == market[0].id);

        if(!submarket && checkboxes[i].checked){

          this.subMarkets.push(market[0]);

        }

        if(submarket && !checkboxes[i].checked){

          var index = this.subMarkets.map(x => {
            return x.Id;
          }).indexOf(checkboxes[i].value);

          this.subMarkets.splice(index, 1);

        }

      } 

    },

    onSubmit(){

      this.$v.$touch();

      if (!this.$v.$invalid) {

        this.addUser();

      }

    },

    addUser(){

      let name = this.fullName.split(/ (.*)/);
      let sub = [];

      for(let i=0; i<this.subMarkets.length; i++){

        sub.push(this.subMarkets[i].id);

      }

      const newUser = {
        name: name[0],
        surname: name[1],
        username: this.email,
        email: this.email,
        company: this.company,
        category: this.category,
        parentMarket: this.parentMarket,
        roles: [this.role],
        subMarkets: sub,
      }

     const token = localStorage.getItem('auth_token');

      this.$http.post('users', newUser, {
        headers: {

        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'

        }}).
        then(response => {

          this.$router.push('/users');
          this.exist = false;

        })
        .catch(error => {

            if(error.response.status === 400) {
            
              if(error.response.data.message.email){

                this.exist = true;

              }

            }else{

              console.error(error.response);

            }

        })

    },

  },
  mounted(){

    this.getFormData();
    this.getMarkets();

  },
};
</script>

<style lang="scss">

.form{
  width:50%;
  padding: 10px;
}

.vs__dropdown-menu{
  max-height: 380px !important;
}

.list-group--form{
 max-height: 380px;
  background:#fff;
  width:92%;
  overflow: hidden;
  overflow-y: scroll;
  position: absolute;
  z-index: 100;

  & li{
    border:none;
    padding-right: 20px;
  }

  & >li:nth-child(even){
    background-color: #F2F5F7;
    color: #939393;
    border:2px #D3DFEF solid;
    margin-bottom: 1px;
  }

  & > li > .checkbox > .checkmark{
    border:none;
    background:transparent;
  }

  &::-webkit-scrollbar-track{
    border-radius: 10px;
    background-color: rgba(226, 229, 235, 0.5);
  }

  &::-webkit-scrollbar{
    width: 5px;
    background-color: #F5F5F5;
  }

  &::-webkit-scrollbar-thumb{
    border-radius: 10px;
    height:50px;
    background-color: #B1B4C1;
  }

}

.form-footer{
  display:flex;
  width:100%;
  justify-content: space-between;
}

.sub-markets-display{
  display:flex;
  overflow:hidden;
  position: relative;

  &__body{
    display:flex;
    flex-direction: row;
    align-items: center;
    position: absolute;
    top:0;
    left:0;
    width:100%;
    height: 150%;
    overflow:hidden;
    overflow-x: scroll;
    white-space: nowrap;
    opacity: 0.8;
    border-right: 30px #f8f8f8 solid;

    & ul{
      padding: 0;
      margin:0;
      position: relative;
    }

    & li{
      display: inline-block;
    }
  }
}

.multi-checkbox-wide{
  display: flex !important;
  width: 100%;
  height: 100%;
  position: absolute;
  align-items: center;
  justify-content: flex-end;
  left: 0;
  top: 0;
  cursor: pointer;
}

</style>
